import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d2d85f2c&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=d2d85f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d85f2c",
  null
  
)

export default component.exports